import axios from "axios";
import { EmployeeID, RefreshToken } from "configs/AppConfig";
import { message } from "antd";
import app from "configs/FirebaseConfig";
import { AUTH_PREFIX_PATH } from "configs/AppConfig";

let AuthService = {};

let hasShownMessage = false; // Flag to track if the message has been shown

AuthService.reloadPage = function () {
  setTimeout(() => {
    return window.location.reload();
  }, 1000);
};

AuthService.refreshToken = async () => {
  return new Promise((resolve) => {
    try {
      fetch(
        `https://securetoken.googleapis.com/v1/token?key=${app._options.apiKey}`,
        {
          method: "POST",
          body: JSON.stringify({
            refresh_token: RefreshToken,
            grant_type: "refresh_token",
          }),
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        },
      )
        .then((res) => res.json())
        .then((res) => {
          const bearerToken = res.access_token;
          localStorage.setItem("bearerToken", bearerToken);
          resolve();
        });
    } catch (error) {
      console.log(error);
    }
  });
};

AuthService.signOut = () => {
  window.localStorage.clear();
  window.sessionStorage.clear();

  // clear non-HttpOnly cookies
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });

  // clear caches
  if ("caches" in window) {
    caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
  }
  window.location.href = `${AUTH_PREFIX_PATH}/login`;
};

AuthService.statusHandler = async function (response) {
  const status = response?.status;

  if (!hasShownMessage) {
    switch (status) {
      case 400:
        message.error(response?.data?.message || "Bad Request");
        break;
      case 500:
        message.error(status + " Internal Server Error");
        break;
      case 403:
        message.error(
          response?.data?.message || status + " User Access Denied",
        );
        break;
      case 404:
        message.error(status + " Data Not Found");
        break;
      case 301:
        message.error(status + " Data Not Available");
        break;
      case 401:
        // message.error(status + " Unauthorized");
        break;
      default:
        break;
    }

    hasShownMessage = true; // Set the flag to true
  }
};

AuthService.permissionsHandler = async function () {
  try {
    const response = await axios({
      url: `/EmployeeService.svc/GetMyAccess`,
      params: {
        EmployeeID: EmployeeID,
      },
    });

    const access = response.data.Data.AccessGranted;

    localStorage.setItem("Permissions", JSON.stringify(access));

    // !access && AuthService.signOut();

    return access;
  } catch (error) {
    if (error.code === "ERR_CANCELED" || error.name === "CanceledError") {
      return null;
    }
    console.log(error);
    const status = error.response ? error.response.status : 500; // Default to 500 if response is undefined
    const errorMessage = error.response
      ? error.response.data
      : { message: "Unknown error occurred" };
    AuthService.statusHandler({ status, data: errorMessage });
    return null;
  } finally {
    // Reset the flag when permissions handling is done
    hasShownMessage = false;
  }
};

export default AuthService;
